import { useState } from 'react';
import { PasswordRecovery } from './components/PasswordRecovery';
import { PrincipalForm } from './components/PrincipalForm';

import './style.css';

export const LoginScreen = () => {

  const [forgot, setForgot] = useState(false)

  return (
    <section className='login'>
      <img src='/aniber-andamios.jpg' alt='Logo Sigia Aníber' className='logo_login'></img>
      {!forgot
        ? <PrincipalForm forgot={forgot} setForgot={setForgot} />
        : <PasswordRecovery forgot={forgot} setForgot={setForgot} />}

    </section>
  )
}
